import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

/*
#tailwind
*/

const Portal = ({ id, children }) => {
  const ref = useRef(document.createElement('div'));

  useEffect(() => {
    const el = ref.current;
    if (id) {
      document.getElementById(id)?.remove();
      el.id = id;
    }
    document.body.appendChild(el);
    return () => el?.remove();
  }, [id]);

  return ReactDOM.createPortal(children, ref.current);
};

Portal.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
};

Portal.defaultProps = {
  id: undefined,
  children: undefined,
};

export default Portal;
